const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the group list search directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('partnersPermissionSelect', ['Application', 'Partners', '$q', function (Application, Partners, $q) {
  return {
    restrict: 'E',
    scope: {
      selected: '=',
      onChange: '&',
    },
    template: require('../../templates/directives/partners-permission-select.html'),
    controller: ['$scope', function($scope) {
      var self = this;
      self.flags = Application.features.flags();
      self.partnerPermissions = [{ label: 'Instance Only', value: 'tenant'}, { label: 'All Extend Accounts', value: 'partner'}, { label: 'Extend Accounts & Instance', value: 'partner_and_tenant'}]
      self.selectedPermission = $scope.selected || 'tenant';

      self.onChange = (permission) => {
        $scope.onChange({ permission });
      }

    }],
    controllerAs: 'partnerSelect'
  };
}]);